import { DisplayMessage } from '../builders/display_message_builder';
import { IDatasourceOptions } from 'core-ts-types';
import { Datasource, IDatasource, IDatasourceConstructor } from 'utility-ng-kernel';

export interface IDisplayMessagesDatasource extends IDatasource<DisplayMessage> {}

angular
  .module('capability-ng-global')
  .factory('ngDisplayMessagesDatasource', function(
    ngDisplayMessageBuilder: typeof DisplayMessage,
    Datasource: IDatasourceConstructor<DisplayMessage>
  ): IDisplayMessagesDatasource {
    return new Datasource({
      builderType: ngDisplayMessageBuilder
    }).configure({
      mergeStrategy: 'merge'
    });
  });



// WEBPACK FOOTER //
// ./app/lib/global/datasources/display_message_datasource.ts